var script = document.createElement("script");
script.src = "https://code.jquery.com/jquery-3.6.3.min.js"; // Check https://jquery.com/ for the current version
document.getElementsByTagName("head")[0].appendChild(script);

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.minicart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;
        var htmlElement = this;
        var handled = true;
        var inMandje = 0;

        jQuery
          .getJSON("/cart.js", function (cart) {
            for (var item of cart.items) {
              if (formData.get("id") == item.id) {
                inMandje = item.quantity;
              }
            }
          })
          .then(function (returndata) {
            if (formData.get("quantity") > voorraad - inMandje) {
              htmlElement.handleErrorMessage(
                "De voorraad van dit artikel is " + voorraad + " stuk(s). Het volledige aantal is in het winkelmandje geplaatst."
              );
              handled = false;
              formData.append("quantity", voorraad - inMandje);
            }
              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    htmlElement.handleErrorMessage(response.description);
                    return;
                  }

                  htmlElement.minicart.renderContents(response);
                  htmlElement.minicart.open(submitButton);

                  if (handled){
                    htmlElement.handleErrorMessage();
                  }  
                  handled = true;
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  inMandje = inMandje + formData.get("quantity");
                  submitButton.classList.remove("loading");
                  submitButton.removeAttribute("aria-disabled");
                  htmlElement
                    .querySelector(".button-overlay-spinner")
                    .classList.add("hidden");
                });
            
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
